export default "__VITE_ASSET__CRE3IaE6__"